import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const CONTRACTORS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('Contractors');
export const CONTRACTORS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	CONTRACTORS_CRUD_ACTION_CONSTANTS
);
